// extracted by mini-css-extract-plugin
module.exports = {"list":"style__list__z6DhL","item":"style__item__Bdw+0"};